import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import {
  GET_DISTRIBUTOR_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
} from "../../../Types";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import {
  Modal,
  Row,
  Col,
  Container,
  Button,
  Overlay,
  Popover,
  toggleUserStatus,
} from "react-bootstrap";
import Moment from "react-moment";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";

import axios from "../../../apis/Api";
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link, Redirect } from "react-router-dom";
import { formatDate } from "../../../utilities/FUNCTIONS";
import ReactToPrint from "react-to-print";
import PlaceholderImage from "../../../assets/Images/placeholder-image.png";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useDispatch } from "react-redux";
import { uploadFile } from "../../../utilities/ImageUpload";
import { isPermittedPage } from "../../../apis/Utility";
import { getImageExtensions } from "../../../utilities/FUNCTIONS";
import {
  AllowOnlyAlpha,
  AllowOnlyDecimal,
  AllowOnlyNumeric,
  formatNumber,
  removeFormatFromNumber,
  AllowOnlyAlphaNumericWithDash,
} from "../../../utilities/Validations";

const KYCListingForm = (props) => {
  const dispatch = useDispatch();
  const [kycList, setKycList] = useState([]);
  const [selectedKyc, setSelectedKyc] = useState(null);
  const [originalKycData, setOriginalKycData] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const cellRefs = useRef({});

  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");

  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  const printRef = useRef();
  const imgUploadRef = useRef();

  // pagination states
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isContractButtonVisible, setIsContractButtonVisible] = useState(false);

  const [ContractStatusOption, setContractStatusOption] = useState([]);
  const [distCenterOptions, setDistCenterOptions] = useState(
    props.selectedAddJobDistCentersList ?? []
  );

  const filterInitialValues = {
    fromDate: new Date(),
    toDate: new Date(),
    shopId: "",
    status: "",
    pageNo: 0,
    searchText: "",
    distributorId: "",
    distcentId: [],
    lenderId: "",
    contractStatus: "",
  };

  const modalInitialValues = {
    id: "",
    cnicBack: "",
    lenderId: "",
    cnicFront: "",
    shopPicture: "",
    ownerPicture: "",
    date: new Date(),
    dateStr: new Date(),
    ownershipType: "",
    shopHeight: 0,
    shopWidth: 0,
    vizId: "",
    financerId: "",
    kycStatus: "",
    contractStatus: "",
    assignLimit: 0,
    reason: "",
    dateOfBirth: new Date(),
    ownerName: "",
    fatherName: "",
    motherName: "",
    cnic: "",
    cnicIssuanceDate: new Date(),
    cnicExpiryDate: new Date(),

    email: "",
    contactNo: "",
    cnicHomeAddress: "",
    currentHomeAddress: "",
    businessName: "",
    businessType: "",
    requiredCredit: 0,
    businessAddress: "",
    userName: "",
  };

  const [filter, setfilter] = useState(filterInitialValues);
  const [modalValues, setModalValues] = useState(modalInitialValues);
  const KycStatusString = (status) => {
    return status.replace("", "");
  };
  const columns = [
    {
      Header: "Kyc Submission Date",
      accessor: "kycSubmissionDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
    {
      Header: "VIZ-ID",
      accessor: "vizID",
    },

    {
      Header: "Shop Name",
      accessor: "shopName",
    },

    {
      Header: "Kyc Status",
      accessor: "kycStatusStr",
    },
    {
      Header: "Contract Status",
      accessor: "contractStatus",
    },
    {
      Header: "Active Status",
      id: "activeStatus",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div>
          <button
            title="Toggle User Active Status"
            onClick={() => toggleActive(original.id)}
            className=" btn btn-sm"
            ref={(el) => (cellRefs.current[original.id] = el)}
            style={{ color: "#e84d15", backgroundColor: "transparent" }}
          >
            <i
              className={
                original.activeStatus
                  ? "fas fa-toggle-on fa-2x"
                  : "fas fa-toggle-off fa-2x"
              }
            ></i>
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      id: "id",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div className="d-flex" style={{ width: "106px" }}>
          <button
            style={{
              display:
                original.kycStatusStr === "Pending" ||
                  original.kycStatusStr === "Approved"
                  ? "none"
                  : "block",
            }}
            onClick={() => editRecord(original.id)}
            className=" btn btn-sm"
          >
            <i className="fas fa-edit"></i>
          </button>
          &nbsp;
          <button
            onClick={() => viewRecord(original.id, false)}
            className="btn btn-sm"
          >
            <i className="fas fa-eye"></i>
          </button>
          {/* &nbsp;
          <button onClick={() => Delete(row.value)} className='btn btn-sm'>
            <i className='fas fa-trash'></i>
          </button> */}
        </div>
      ),
    },
  ];

  const statusOptions = [
    {
      label: "Pending",
      value: 5,
    },
    {
      label: "Approved",
      value: 6,
    },
    {
      label: "Rejected",
      value: 7,
    },
    {
      label: "Need More Info",
      value: 8,
    },
    {
      label: "Error",
      value: 9,
    },
  ];

  const ownershipColumns = [
    {
      label: "Owned",
      value: "owned",
    },
    {
      label: "Rented",
      value: "rented",
    },
  ];

  const getKycList = (request) => {
    axios
      .post(`api/LenderKYC/GetKYCListingForm`, request)
      .then(({ data }) => {
        setKycList(data?.response?.data);
        setTotalRecords(data?.response?.totalRecords);
      })
      .catch(function (error) { });
  };

  const toggleActive = async (Id) => {
    await axios
      .get(`api/LenderKYC/ActiveDeactiveKyc/${Id}`)
      .then(({ data }) => {
        if (data.response == null) {
          toast.error("record not found");
          return;
        }
        if (cellRefs.current[Id]) {
          if (data.response) {
            cellRefs.current[Id].innerHTML =
              '<i class="fas fa-toggle-on fa-2x"></i>';
          } else {
            cellRefs.current[Id].innerHTML =
              '<i class="fas fa-toggle-off fa-2x"></i>';
          }
        }
        toast.success("User status updated successfully");
      })
      .catch(function (error) { });
  };

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setDistCenterOptions([]);
    setfilter(filterInitialValues);
  };
  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
    axios
      .get(`api/LenderKYC/GetContractStatusDDL`)
      .then(({ data }) => {
        setContractStatusOption(data?.response);
      })
      .catch(function (error) { });
  }, []);

  useEffect(() => {
    if (filter.distributorId) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {distributorIds: filter.distributorId.value},
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    }
  }, [filter.distributorId]);

  function formRequestObject() {
    let requestData = {
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.fromDate && formatDate(filter.toDate),
      status: filter.status?.value,
      ContractStatus: filter.contractStatus?.value,
      shopId: filter.shopId,
      pageSize: currentPageSize,
      pageNo: filter.pageNo,
      searchText: filter.searchText,
      distId: filter.distributorId.value,
      distCenterId: filter.distcentId.value,
      financerId: filter.lenderId.value,
    };

    return requestData;
  }

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setfilter({ ...filter, searchText: text });
    var request = {
      ...formRequestObject(),
      searchText: text,
      currentPageNo: 0,
    };
    fetchReportData(request);
  };

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    getKycList(finalRequest);
  }

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
  };

  const Download = () => {
    let request = { ...formRequestObject(), isExport: true };
    props.downloadJob(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageNo: 0, pageSize: pageSize };
    fetchReportData(request);
  };

  const getRecord = (id, isEdit = false) => {
    axios
      .get(`api/LenderKYC/GetKycSingleRecord/${id}`)
      .then(({ data }) => {
        setSelectedKyc(data?.response);
        setOriginalKycData({ ...data?.response });
        setModalValues({ ...data?.response });
        let ownership = ownershipColumns.find(
          (x) => x.value == data?.response?.ownershipType
        );
        if (isEdit) {
          setModalValues({
            ...data?.response,
            ownershipType: ownership,
            cnic: formatNumber(data?.response.cnic, false),
            contactNo: formatNumber(data?.response.contactNo, true),
          });
        } else {
          setModalValues({
            ...data?.response,
            cnic: formatNumber(data?.response.cnic, false),
            contactNo: formatNumber(data?.response.contactNo, true),
          });
          setIsContractButtonVisible(
            data.response.kycStatus.toLowerCase() == "approved" &&
            data.response.contractStatus.toLowerCase() == "pending" &&
            isPermittedPage("Edit", props.actions, props.userRole)
          );
        }
      })
      .catch(function (error) { });
  };

  const viewRecord = (id, download) => {
    setIsDownload(download);
    setIsView(true);
    setReadOnly(true);
    setIsEdit(false);
    getRecord(id);
  };

  const editRecord = (id) => {
    setIsDownload(false);
    setReadOnly(false);
    setIsView(false);
    setIsEdit(true);
    getRecord(id, true);
  };

  const closeModal = () => {
    setIsView(false);
    setIsEdit(false);
    setReadOnly(false);
    setSelectedKyc(null);
  };
  useEffect(() => {
    setDistCenterOptions(
      props.selectedAddJobDistCentersList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.selectedAddJobDistCentersList]);

  const resetData = () => {
    let ownership = ownershipColumns.find(
      (x) => x.value == originalKycData?.ownershipType
    );
    setModalValues({ ...originalKycData, ownershipType: ownership });
  };

  const removeImage = (fieldName) => {
    modalValues[fieldName] = "";
  };

  const openUploadImage = (img) => {
    setSelectedImg(img);
    imgUploadRef.current.click();
  };

  const saveImage = (event) => {
    //debugger;
    dispatch(showLoading());
    const extension = getImageExtensions();
    if (event.target.files.length > 0) {
      let currentExtension = event.target.files[0].name
        .split(".")
        .pop()
        .toLowerCase();
      if (!extension.includes(currentExtension)) {
        dispatch(hideLoading());
        toast.error("Selected invalid file extension");
        return;
      }
      uploadFile(event.target.files[0])
        .then((response) => {
          dispatch(hideLoading());
          imgUploadRef.current.value = null;
          modalValues[selectedImg] = response;
          setSelectedImg("");
        })
        .catch(function (error) {
          imgUploadRef.current.value = null;
          dispatch(hideLoading());
          toast.error(error);
        });
    } else {
      dispatch(hideLoading());
    }
  };

  const checkStatus = (type, current) => {
    switch (type) {
      case "revert":
        return 4;
      case "finalize":
        return 5;
      default:
        return current;
    }
  };

  const saveToasterMessage = (type) => {
    switch (type) {
      case 4:
        return "Record reverted to Shopkeeper";
      case 5:
        return "Record finalized";
      default:
        return "Record updated";
    }
  };

  const saveData = (formData, type) => {
    //let currentStatus = checkStatus(type, formData.status);
    if (formData.cnic != "" && formData.cnic != null) {
      formData.cnic = removeFormatFromNumber(formData.cnic);
    }
    if (formData.contactNo != "" && formData.contactNo != null) {
      formData.contactNo = removeFormatFromNumber(formData.contactNo);
    }
    let req = {
      ...formData,
      //status: currentStatus,
      // ownershipType:
      //   formData.ownershipType.value == undefined
      //     ? formData.ownershipType
      //     : formData.ownershipType.value,
    };

    dispatch(showLoading());
    axios
      .post(`api/LenderKYC/FormListUpdateUserKycProcess`, req)
      .then(({ data }) => {
        if (data.isSuccess) {
          toast.success(data.message);
          // toast.success(saveToasterMessage(currentStatus));
          closeModal();
          getData(0);
        } else {
          toast.error(data.message);
        }
        dispatch(hideLoading());
      })
      .catch(function (error) {
        if (!error.response.data.isSuccess) {
          toast.error(error.response.data.message || "Bad request");
        }
        dispatch(hideLoading());
      });
  };

  useEffect(() => {
    // getKycList({})
    fetchReportData();
  }, []);

  const SyncContractStatus = (vizcode) => {
    dispatch(showLoading());
    axios
      .post(
        `api/LenderKYC/CreditBook/ChangeContractStatusForWeb?vizSHopCode=${vizcode}`
      )
      .then(({ data }) => {
        data.isSuccess
          ? toast.success(data.response)
          : toast.error(data.response);
        dispatch(hideLoading());
      })
      .catch(function (error) {
        dispatch(hideLoading());
      });
  };

  return (
    <>
      <VzPageContainer title="KYC Form List">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>KYC Form List</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Row>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  type="distributor"
                                  label="Distributor"
                                  name="distributor"
                                  options={props.allDistributorList}
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      distributorId: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                      distcentId: [],
                                    });
                                  }}
                                  value={filter.distributorId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  type="distcent"
                                  label="Dist Center"
                                  options={distCenterOptions}
                                  name="distcent"
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      distcentId: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.distcentId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  type="financer"
                                  label="Financer"
                                  options={props.allLenderList}
                                  name="financer"
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      lenderId: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.lenderId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="shopId"
                                  label="VIZ-ID"
                                  name="shopId"
                                  handleOnChange={(e) => {
                                    setfilter({
                                      ...filter,
                                      shopId: AllowOnlyAlphaNumericWithDash(e),
                                    });
                                  }}
                                  value={filter.shopId}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="KYC Status"
                                  name="status"
                                  options={statusOptions}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      status: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.status}
                                />
                              </Col>
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Contract Status"
                                  name="contractStatus"
                                  options={ContractStatusOption}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      contractStatus: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.contractStatus}
                                />
                              </Col>
                              <Row style={{ paddingRight: 0 }}>
                                <Col xs={12} md={6}>
                                  <FormikControl
                                    // formik={formik}
                                    control="date"
                                    label="From Date"
                                    name="fromDate"
                                    handleOnChange={(value) => {
                                      setfilter({ ...filter, fromDate: value });
                                    }}
                                    value={filter.fromDate}
                                  />
                                </Col>
                                <Col xs={12} md={6}>
                                  <FormikControl
                                    // formik={formik}
                                    control="date"
                                    label="To Date"
                                    name="toDate"
                                    handleOnChange={(value) => {
                                      setfilter({ ...filter, toDate: value });
                                    }}
                                    value={filter.toDate}
                                  />
                                </Col>
                              </Row>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={kycList ?? []}
              columns={columns}
              getTrProps={(event, data) => { }}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords ?? 0}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
        <Modal
          show={isView || isEdit}
          onHide={closeModal}
          backdrop="static"
          keyboard={false}
          size="xl"
        >
          <Formik
            enableReinitialize
            initialValues={modalValues}
            validationSchema={null}
          // onSubmit={saveData}
          >
            {(formik) => (
              <Form autoComplete="off">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    {isDownload && (
                      <ReactToPrint
                        trigger={() => <Button>Download</Button>}
                        content={() => printRef.current}
                        documentTitle="KYC"
                      />
                    )}
                    {/* {isEdit && <Button onClick={resetData}>Reset</Button>} */}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body ref={printRef}>
                  {!isEdit ? (
                    <>
                      <Row>
                        <Col>
                          <div className="card-header">
                            <h5>
                              <b style={{ color: " #ea5f2d" }}>KYC Listing:</b>
                            </h5>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                            }}
                          >
                            Main Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    style={{ margin: "25px 0px 0px 0px" }}
                                    control="date"
                                    type="date"
                                    // label='Shop Owner Name'
                                    name="date"
                                    value={modalValues.date}
                                    handleOnChange={(e) =>
                                      (modalValues.date = e)
                                    }
                                    readOnly="true"
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                VIZ ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="vizId"
                                    // label='Shop Owner Name'
                                    name="vizId"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.vizId = e)
                                    }
                                    value={modalValues.vizId}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Financer ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="financerId"
                                    // label="Father's Name"
                                    name="financerId"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.financerId = e)
                                    }
                                    value={modalValues.financerId}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                KYC Status
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="kycStatus"
                                    // label="Mother's Name"
                                    name="kycStatus"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.kycStatus = e)
                                    }
                                    value={modalValues.kycStatus}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contract Status
                              </Col>
                              <Col xs={4}>
                                <Row>
                                  <Col xl={isContractButtonVisible ? 10 : 12}>
                                    <div className="form-group">
                                      <FormikControl
                                        formik={formik}
                                        control="input"
                                        type="contractStatus"
                                        // label="Father's Name"
                                        name="contractStatus"
                                        readOnly="true"
                                        handleOnChange={(e) =>
                                          (modalValues.contractStatus = e)
                                        }
                                        value={modalValues.contractStatus}
                                      />
                                    </div>
                                  </Col>
                                  {isContractButtonVisible ? (
                                    <Col xs={2}>
                                      <button
                                        style={{ marginTop: "4px" }}
                                        className="btn btn-sm btn-warning"
                                        title="Sync Contract"
                                        onClick={() =>
                                          SyncContractStatus(modalValues.vizId)
                                        }
                                      >
                                        <i className="fa fa-history"></i>
                                      </button>
                                    </Col>
                                  ) : null}
                                </Row>
                              </Col>
                              <Col xs={2} className="text-right">
                                Assign Limit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="assignLimit"
                                    // label="Mother's Name"
                                    name="assignLimit"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.assignLimit = e)
                                    }
                                    value={modalValues.assignLimit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Reason for Rejection
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="reason"
                                    // label='CNIC No.'
                                    name="reason"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.reason = e)
                                    }
                                    value={modalValues.reason}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Front Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not found"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicFront || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("cnicFront")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() => removeImage("cnicFront")}
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Back Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicBack || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("cnicBack")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() => removeImage("cnicBack")}
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-91px"
                            }}
                          >
                            Personal Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Owner Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="ownerName"
                                    readOnly="true"
                                    // label='Shop Owner Name'
                                    name="ownerName"
                                    handleOnChange={(e) =>
                                      (modalValues.ownerName = e)
                                    }
                                    value={modalValues.ownerName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Father Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="fatherName"
                                    // label='Shop Owner Name'
                                    name="fatherName"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.fatherName = e)
                                    }
                                    value={modalValues.fatherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                DOB
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    type="dateOfBirth"
                                    // label="Father's Name"
                                    name="dateOfBirth"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.dateOfBirth = e)
                                    }
                                    value={modalValues.dateOfBirth}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Mother Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={70}
                                    type="motherName"
                                    // label="Mother's Name"
                                    name="motherName"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.motherName = e)
                                    }
                                    value={modalValues.motherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="cnic"
                                    // label="Father's Name"
                                    name="cnic"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.cnic = e)
                                    }
                                    value={modalValues.cnic}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                CNIC Issuance Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Issuance Date'
                                    name="cnicIssuanceDate"
                                    readOnly="true"
                                    handleOnChange={(value) => {
                                      modalValues.cnicIssuanceDate = value;
                                    }}
                                    value={modalValues.cnicIssuanceDate}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Expiry Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Expiry Date'
                                    name="cnicExpiryDate"
                                    readOnly="true"
                                    handleOnChange={(value) => {
                                      modalValues.cnicExpiryDate = value;
                                    }}
                                    value={modalValues.cnicExpiryDate}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Email
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="email"
                                    readOnly="true"
                                    // label='CNIC Expiry Date'
                                    name="email"
                                    handleOnChange={(value) => {
                                      modalValues.email = value;
                                    }}
                                    value={modalValues.email}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contact #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    // label='CNIC Issuance Date'
                                    name="contactNo"
                                    readOnly="true"
                                    handleOnChange={(value) => {
                                      modalValues.contactNo = value;
                                    }}
                                    value={modalValues.contactNo}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                UserName
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    name="UserName"
                                    readOnly="true"
                                    value={modalValues.userName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Home Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <div className="form-group">
                                    <FormikControl
                                      formik={formik}
                                      control="input"
                                      type="currentHomeAddress"
                                      // label='CNIC No.'
                                      readOnly="true"
                                      name="currentHomeAddress"
                                      handleOnChange={(e) =>
                                        (modalValues.currentHomeAddress = e)
                                      }
                                      value={modalValues.currentHomeAddress}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="cnicHomeAddress"
                                    // label='CNIC No.'
                                    name="cnicHomeAddress"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.cnicHomeAddress = e)
                                    }
                                    value={modalValues.cnicHomeAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Owner Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.ownerPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("ownerPicture")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() =>
                                        removeImage("ownerPicture")
                                      }
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Shop Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.shopPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                {isEdit && (
                                  <div className="d-flex  justify-content-center ms-2">
                                    <button
                                      onClick={() =>
                                        openUploadImage("shopPicture")
                                      }
                                      className=" btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                    {/* &nbsp; */}
                                    <button
                                      onClick={() => removeImage("shopPicture")}
                                      className="btn btn-sm m-0"
                                      readOnly="true"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>{" "}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-30px",
                            }}
                          >
                            Business Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessName"
                                    // label='Shop Owner Name'
                                    name="businessName"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.businessName = e)
                                    }
                                    value={modalValues.businessName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop OwnerShip
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    type="ownershipType"
                                    // label='Shop Ownership'
                                    name="ownershipType"
                                    readOnly="true"
                                    options={ownershipColumns}
                                    handleOnChange={(e) =>
                                      (modalValues.ownershipType = e)
                                    }
                                    value={modalValues.ownershipType}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Shop height
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopHeight"
                                    // label="Father's Name"
                                    name="shopHeight"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.shopHeight = e)
                                    }
                                    value={modalValues.shopHeight}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop Width
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopWidth"
                                    // label="Mother's Name"
                                    name="shopWidth"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.shopWidth = e)
                                    }
                                    value={modalValues.shopWidth}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Type
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessType"
                                    // label="Father's Name"
                                    name="businessType"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.businessType = e)
                                    }
                                    value={modalValues.businessType}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Required Credit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="requiredCredit"
                                    // label="Mother's Name"
                                    name="requiredCredit"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.requiredCredit = e)
                                    }
                                    value={modalValues.requiredCredit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessAddress"
                                    readOnly="true"
                                    // label='CNIC No.'
                                    name="businessAddress"
                                    handleOnChange={(e) =>
                                      (modalValues.businessAddress = e)
                                    }
                                    value={modalValues.businessAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col>
                          <div className="card-header">
                            <div style={{ display: "flex", alignItems: "center", position: "relative" }}>

                              {/* Left text */}
                              <b style={{ color: "#ea5f2d" }}>KYC Listing:</b>

                              {/* Center text */}
                              <div style={{
                                marginLeft: "40px",
                                color: "#ed8856ff"
                              }}>
                                {modalValues.previousSubmittedMessage}
                              </div>

                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                            }}
                          >
                            Main Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    style={{ margin: "20px 0px 0px 0px" }}
                                    formik={formik}
                                    control="date"
                                    type="date"
                                    readOnly="true"
                                    // label='Shop Owner Name'
                                    name="date"
                                    value={modalValues.date}
                                    handleOnChange={(e) =>
                                      (modalValues.date = e)
                                    }
                                    isDisabled={isView}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                VIZ ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="vizId"
                                    readOnly="true"
                                    // label='Shop Owner Name'
                                    name="vizId"
                                    handleOnChange={(e) =>
                                      (modalValues.vizId = e)
                                    }
                                    value={modalValues.vizId}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Financer ID
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="financerId"
                                    readOnly="true"
                                    // label="Father's Name"
                                    name="financerId"
                                    handleOnChange={(e) =>
                                      (modalValues.financerId = e)
                                    }
                                    value={modalValues.financerId}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                KYC Status
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    readOnly="true"
                                    type="kycStatus"
                                    // label="Mother's Name"
                                    name="kycStatus"
                                    handleOnChange={(e) =>
                                      (modalValues.kycStatus = e)
                                    }
                                    value={modalValues.kycStatus}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contract Status
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    readOnly="true"
                                    type="contractStatus"
                                    // label="Father's Name"
                                    name="contractStatus"
                                    handleOnChange={(e) =>
                                      (modalValues.contractStatus = e)
                                    }
                                    value={modalValues.contractStatus}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Assign Limit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    readOnly="true"
                                    control="input"
                                    type="assignLimit"
                                    // label="Mother's Name"
                                    name="assignLimit"
                                    handleOnChange={(e) =>
                                      (modalValues.assignLimit = e)
                                    }
                                    value={modalValues.assignLimit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Reason for Rejection
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    readOnly="true"
                                    control="input"
                                    type="reason"
                                    // label='CNIC No.'
                                    name="reason"
                                    handleOnChange={(e) =>
                                      (modalValues.reason = e)
                                    }
                                    value={modalValues.reason}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Front Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not found"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicFront || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() => openUploadImage("cnicFront")}
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("cnicFront")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>CNIC Back Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.cnicBack || PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() => openUploadImage("cnicBack")}
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("cnicBack")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-150px"
                            }}
                          >
                            Personal Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Owner Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={70}
                                    type="ownerName"
                                    // label='Shop Owner Name'
                                    name="ownerName"
                                    handleOnChange={(e) =>
                                    (modalValues.ownerName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.ownerName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Father Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="fatherName"
                                    maxLength={70}
                                    // label='Shop Owner Name'
                                    name="fatherName"
                                    handleOnChange={(e) =>
                                    (modalValues.fatherName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.fatherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                DOB
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    type="date"
                                    // label="Father's Name"
                                    name="dateOfBirth"
                                    handleOnChange={(e) =>
                                      (modalValues.dateOfBirth = e)
                                    }
                                    value={modalValues.dateOfBirth}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Mother Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={70}
                                    type="motherName"
                                    // label="Mother's Name"
                                    name="motherName"
                                    handleOnChange={(e) =>
                                    (modalValues.motherName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.motherName}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="cnicNumber"
                                    type="cnic"
                                    // label="Father's Name"
                                    name="cnic"
                                    handleOnChange={(e) =>
                                      (modalValues.cnic = e)
                                    }
                                    value={modalValues.cnic}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                CNIC Issuance Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Issuance Date'
                                    name="cnicIssuanceDate"
                                    handleOnChange={(value) => {
                                      modalValues.cnicIssuanceDate = value;
                                    }}
                                    value={modalValues.cnicIssuanceDate}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Expiry Date
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="date"
                                    // label='CNIC Expiry Date'
                                    name="cnicExpiryDate"
                                    handleOnChange={(value) => {
                                      modalValues.cnicExpiryDate = value;
                                    }}
                                    value={modalValues.cnicExpiryDate}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Email
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="email"
                                    readOnly={modalValues.kycStatus === "Error" ? false : true}
                                    // label='CNIC Expiry Date'
                                    name="email"
                                    handleOnChange={(value) => {
                                      modalValues.email = value;
                                    }}
                                    value={modalValues.email}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Contact #
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="contactNumber"
                                    // label='CNIC Issuance Date'
                                    name="contactNo"
                                    handleOnChange={(value) => {
                                      modalValues.contactNo = value;
                                    }}
                                    value={modalValues.contactNo}
                                  />
                                </div>
                              </Col>
                              <Col xs={6}></Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Home Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <div className="form-group">
                                    <FormikControl
                                      formik={formik}
                                      maxLength={254}
                                      control="input"
                                      type="currentHomeAddress"
                                      // label='CNIC No.'
                                      name="currentHomeAddress"
                                      handleOnChange={(e) =>
                                        (modalValues.currentHomeAddress = e)
                                      }
                                      value={modalValues.currentHomeAddress}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                CNIC Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={254}
                                    type="cnicHomeAddress"
                                    // label='CNIC No.'
                                    name="cnicHomeAddress"
                                    handleOnChange={(e) =>
                                      (modalValues.cnicHomeAddress = e)
                                    }
                                    value={modalValues.cnicHomeAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                        <Col md={4} sm={12}>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Owner Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.ownerPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() =>
                                      openUploadImage("ownerPicture")
                                    }
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("ownerPicture")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="d-flex justify-content-end">
                            <Col xs={12}>
                              <div className="form-group  ">
                                <div className="d-flex flex-column align-items-center">
                                  <p>Shop Picture</p>
                                  <img
                                    className="kyc-form-img"
                                    style={{ border: "1px solid #ccc" }}
                                    alt="not fount"
                                    width={"200px"}
                                    height={"125px"}
                                    src={
                                      modalValues?.shopPicture ||
                                      PlaceholderImage
                                    }
                                  />
                                  <input
                                    ref={imgUploadRef}
                                    hidden
                                    type="file"
                                    name="imageFile"
                                    accept="image/*"
                                    onChange={(event) => saveImage(event)}
                                  />
                                </div>
                                <div className="d-flex  justify-content-center ms-2">
                                  <button
                                    onClick={() =>
                                      openUploadImage("shopPicture")
                                    }
                                    className=" btn btn-sm m-0"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  {/* &nbsp; */}
                                  <button
                                    onClick={() => removeImage("shopPicture")}
                                    className="btn btn-sm m-0"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </Col>
                          </Row>{" "}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} sm={12}>
                          <h6
                            style={{
                              color: "#ea5f2d",
                              marginLeft: "20px",
                              marginTop: "-100px",
                            }}
                          >
                            Business Info:
                          </h6>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Name
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessName"
                                    // label='Shop Owner Name'
                                    name="businessName"
                                    maxLength={70}
                                    handleOnChange={(e) =>
                                    (modalValues.businessName =
                                      AllowOnlyAlpha(e))
                                    }
                                    value={modalValues.businessName}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop OwnerShip
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    type="ownershipType"
                                    // label='Shop Ownership'
                                    name="ownershipType"
                                    options={ownershipColumns}
                                    handleOnChange={(e) =>
                                      (modalValues.ownershipType = e)
                                    }
                                    value={modalValues.ownershipType}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Shop height
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopHeight"
                                    // label="Father's Name"
                                    name="shopHeight"
                                    maxLength={12}
                                    handleOnChange={(e) =>
                                    (modalValues.shopHeight =
                                      AllowOnlyDecimal(e))
                                    }
                                    value={modalValues.shopHeight}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Shop Width
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="shopWidth"
                                    maxLength={12}
                                    // label="Mother's Name"
                                    name="shopWidth"
                                    handleOnChange={(e) =>
                                    (modalValues.shopWidth =
                                      AllowOnlyDecimal(e))
                                    }
                                    value={modalValues.shopWidth}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Type
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="businessType"
                                    // label="Father's Name"
                                    name="businessType"
                                    readOnly="true"
                                    handleOnChange={(e) =>
                                      (modalValues.businessType = e)
                                    }
                                    value={modalValues.businessType}
                                  />
                                </div>
                              </Col>
                              <Col xs={2} className="text-right">
                                Required Credit
                              </Col>
                              <Col xs={4}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    type="requiredCredit"
                                    maxLength={11}
                                    // label="Mother's Name"
                                    name="requiredCredit"
                                    handleOnChange={(e) =>
                                    (modalValues.requiredCredit =
                                      AllowOnlyNumeric(e))
                                    }
                                    value={modalValues.requiredCredit}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                          <Row>
                            <div className="d-flex justify-content-between mx-2 align-items-center">
                              <Col xs={2} className="text-right">
                                Business Address
                              </Col>
                              <Col xs={10}>
                                <div className="form-group">
                                  <FormikControl
                                    formik={formik}
                                    control="input"
                                    maxLength={254}
                                    type="businessAddress"
                                    // label='CNIC No.'
                                    name="businessAddress"
                                    handleOnChange={(e) =>
                                      (modalValues.businessAddress = e)
                                    }
                                    value={modalValues.businessAddress}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                </Modal.Body>
                {isEdit && modalValues?.status != 4 && (
                  <Modal.Footer className="d-flex justify-content-between float-right">
                    {
                      <div>
                        {/* <Button className="btn btn-default" onClick={resetData}>
                           Cancel
                         </Button> */}

                        <Button
                          className="btn btn-primary mx-4"
                          onClick={() => saveData(formik.values, "save")}
                        >
                          Save
                        </Button>
                      </div>
                    }
                  </Modal.Footer>
                )}
              </Form>
            )}
          </Formik>
        </Modal>
      </VzPageContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],

    selectedAddJobDistCentersList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost
})(KYCListingForm);
